function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { getLiveChannels, openModal } from "@common/actions";
import ChannelListItem from "@common/components/Settings/ChannelsSetting/ChannelListItem";
import SettingItem from "@common/components/Settings/SettingItem";
import SettingsModalContentWrapper from "@common/components/Settings/SettingsModalContentWrapper";
import { sort } from "@common/services/helpers";
import { changeWebSetting, convertToDeviceSettingsItemList, findDeviceSettingsItem } from "@common/utils/helpers";
import { DISABLE_CHANNEL_REORDER, ROUTE_ON_RECORD_INITIAL_PAGE_SIZE, SEARCH_DEBOUNCE_TIME } from "@config/constants";
import Input from "@material-ui/core/Input";
import { isEmpty, isEqual } from "lodash";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
var ChannelsSetting = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(ChannelsSetting, SettingItem);
    var _super = _create_super(ChannelsSetting);
    function ChannelsSetting(props) {
        _class_call_check(this, ChannelsSetting);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "handleChanges", function(newProfileSettings) {
            var _this_props = _this.props, onChangeHandler = _this_props.onChangeHandler, profileSettings = _this_props.profileSettings;
            var newDeviceSettingsItemList = newProfileSettings.web_settings.DeviceSettingsItemList;
            // Check if some of the channels are unlocked
            // Ask for PIN
            var shouldRequirePin = newDeviceSettingsItemList.some(function(param) {
                var newChannelSettings = param.channelSettings, channelInfo = param.channelInfo;
                var channelItem = findDeviceSettingsItem(profileSettings.web_settings.DeviceSettingsItemList, channelInfo.id);
                var channelLocked = channelItem && channelItem.channelSettings.locked;
                return !newChannelSettings.locked && channelLocked;
            });
            onChangeHandler && onChangeHandler(newProfileSettings, shouldRequirePin);
        });
        _define_property(_assert_this_initialized(_this), "onDragEnd", function(params) {
            var srcIndex = params.source.index;
            var destIndex = params.destination.index;
            var channels = _this.state.channels;
            var profileSettings = _this.props.profileSettings;
            channels.splice(destIndex, 0, channels.splice(srcIndex, 1)[0]);
            var DeviceSettingsItemList = convertToDeviceSettingsItemList(channels, _this.state.DeviceSettingsItemList);
            _this.setState({
                channels: channels,
                DeviceSettingsItemList: DeviceSettingsItemList
            });
            _this.handleChanges(changeWebSetting(profileSettings, {
                DeviceSettingsItemList: DeviceSettingsItemList
            }));
        });
        _define_property(_assert_this_initialized(_this), "onChannelSettingsToggle", function(setting, id) {
            var profileSettings = _this.props.profileSettings;
            var DeviceSettingsItemList = _this.state.DeviceSettingsItemList.map(function(obj) {
                var newSettingState = !obj.channelSettings[setting];
                var oldDeviceSetting = profileSettings.web_settings.DeviceSettingsItemList.find(function(e) {
                    return e.channelInfo.id === id;
                });
                var _obj;
                return obj.channelInfo.id === id ? _object_spread_props(_object_spread({}, obj), {
                    channelSettings: _object_spread_props(_object_spread({}, obj.channelSettings), (_obj = {}, _define_property(_obj, setting, newSettingState), _define_property(_obj, "lockedModified", setting === "locked" && oldDeviceSetting !== undefined && oldDeviceSetting.channelSettings.locked !== newSettingState), _obj))
                }) : obj;
            });
            _this.setState({
                DeviceSettingsItemList: DeviceSettingsItemList
            });
            _this.handleChanges(changeWebSetting(profileSettings, {
                DeviceSettingsItemList: DeviceSettingsItemList
            }));
        });
        _define_property(_assert_this_initialized(_this), "onHideToggle", function(id) {
            _this.onChannelSettingsToggle("visible", id);
        });
        _define_property(_assert_this_initialized(_this), "onLockToggle", function(id) {
            _this.onChannelSettingsToggle("locked", id);
        });
        _define_property(_assert_this_initialized(_this), "onSearchChange", function(e) {
            var searchValue = e.target.value;
            _this.setState({
                searchValue: searchValue
            });
            clearTimeout(_this.searchTimeout);
            _this.searchTimeout = setTimeout(function() {
                _this.setState({
                    filterQuery: searchValue,
                    isDraggable: isEmpty(searchValue)
                });
            }, SEARCH_DEBOUNCE_TIME);
        });
        _define_property(_assert_this_initialized(_this), "renderSearchContainer", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsxs("div", {
                className: "search-input-container",
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        onChange: _this.onSearchChange,
                        type: "text",
                        className: "ux-input search-input",
                        value: _this.state.searchValue,
                        placeholder: i18n.search.placeholderShort
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-search",
                        tabIndex: "0",
                        "data-for": "header-tooltip"
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderTableHeader", function() {
            var i18n = _this.props.i18n;
            if (_this.state.noChannelsFound) {
                return;
            }
            return /*#__PURE__*/ _jsxs("div", {
                className: "channels-table-wrap channels-table-labels",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "channels-table__item",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "channels-table__item-text",
                            children: i18n.settings.hideChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "channels-table__item",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "channels-table__item-text",
                            children: i18n.settings.lockChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "channels-table__item channels-table__item__last-child",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "channels-table__item-text",
                            children: _this.state.isDraggable && !DISABLE_CHANNEL_REORDER && i18n.settings.changeChannelsOrder
                        })
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderDragableItems", function(provided, snapshot) {
            var _this_state = _this.state, DeviceSettingsItemList = _this_state.DeviceSettingsItemList, channels = _this_state.channels, _this_state_filterQuery = _this_state.filterQuery, filterQuery = _this_state_filterQuery === void 0 ? "" : _this_state_filterQuery;
            var i18n = _this.props.i18n;
            var channelsTemplate = channels === null || channels === void 0 ? void 0 : channels.flatMap(function(channel, index) {
                var shown = isEmpty(filterQuery) ? true : channel.name.toLowerCase().indexOf(filterQuery.toLowerCase()) !== -1;
                var item = findDeviceSettingsItem(DeviceSettingsItemList, channel.id);
                return shown ? /*#__PURE__*/ _jsx(ChannelListItem, {
                    isDraggable: _this.state.isDraggable,
                    index: index,
                    visible: item ? item.channelSettings.visible : true,
                    locked: item === null || item === void 0 ? void 0 : item.channelSettings.locked,
                    channel: channel,
                    onLockToggle: function() {
                        return _this.onLockToggle(channel.id);
                    },
                    onHideToggle: function() {
                        return _this.onHideToggle(channel.id);
                    }
                }, channel.id) : [];
            });
            var noChannelsFound = isEmpty(channelsTemplate);
            _this.setState({
                noChannelsFound: noChannelsFound
            });
            return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                ref: provided.innerRef
            }, provided.droppableProps), {
                children: [
                    !noChannelsFound && channelsTemplate,
                    provided.placeholder
                ]
            }));
        });
        _define_property(_assert_this_initialized(_this), "renderPlaceholder", function() {
            var _this_state = _this.state, noChannelsFound = _this_state.noChannelsFound, filterQuery = _this_state.filterQuery;
            var i18n = _this.props.i18n;
            if (noChannelsFound) {
                return /*#__PURE__*/ _jsx("p", {
                    className: "text",
                    style: {
                        marginTop: 30
                    },
                    children: isEmpty(filterQuery) ? i18n.common.loading : i18n.settings.noChannelsFound
                });
            }
        });
        _this.searchTimeout = null;
        var sortedChannels = Object.values(sort(_this.props.liveChannels, false));
        var DeviceSettingsItemList = _this.props.profileSettings.web_settings.DeviceSettingsItemList;
        _this.state = {
            isDraggable: true,
            searchValue: undefined,
            filterQuery: undefined,
            channels: sortedChannels,
            DeviceSettingsItemList: convertToDeviceSettingsItemList(sortedChannels, DeviceSettingsItemList),
            noChannelsFound: false
        };
        return _this;
    }
    _create_class(ChannelsSetting, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                isEmpty(this.props.liveChannels) && this.props.getLiveChannels();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                _get(_get_prototype_of(ChannelsSetting.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
                // Make sure we use the latest profileSettings, liveChannels
                if (!isEqual(prevProps.profileSettings, this.props.profileSettings) || !isEqual(prevProps.liveChannels, this.props.liveChannels)) {
                    var _this_props = this.props, profileSettings = _this_props.profileSettings, liveChannels = _this_props.liveChannels;
                    var channels = Object.values(sort(liveChannels, false));
                    this.setState({
                        channels: channels,
                        DeviceSettingsItemList: convertToDeviceSettingsItemList(channels, profileSettings.web_settings.DeviceSettingsItemList)
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs(SettingsModalContentWrapper, {
                    title: i18n.settings.controlChannels,
                    children: [
                        this.renderSearchContainer(),
                        this.renderTableHeader(),
                        this.renderPlaceholder(),
                        /*#__PURE__*/ _jsx(DragDropContext, {
                            onDragEnd: this.onDragEnd,
                            children: /*#__PURE__*/ _jsx(Droppable, {
                                droppableId: "droppable-1",
                                children: function(provided, snapshot) {
                                    return _this.renderDragableItems(provided, snapshot);
                                }
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ChannelsSetting;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, liveChannels = param.liveChannels;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        liveChannels: liveChannels
    };
};
export default connect(mapStateToProps, {
    openModal: openModal,
    getLiveChannels: getLiveChannels
})(ChannelsSetting);
